export default __webpack_public_path__ + "static/media/pengajuan_surat.59778487.png";